import { render } from "./NewRule.vue?vue&type=template&id=73737484"
import script from "./NewRule.vue?vue&type=script&lang=js"
export * from "./NewRule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__